"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSON = void 0;
const react_1 = __importDefault(require("react"));
const uuid_1 = require("./uuid");
const context_1 = require("./context");
const GeoJSONComponent = ({ id = (0, uuid_1.uuidv4)(), map, data, layers, children, onClick, onMouseEnter, onMouseLeave, onMouseMove, }) => {
    // unmount hook
    react_1.default.useEffect(() => {
        layers.forEach((layer) => {
            if (onClick) {
                map.on("click", layer.id, onClick);
            }
            map.on("mouseenter", layer.id, (e) => {
                map.getCanvas().style.cursor = "pointer";
                if (onMouseEnter) {
                    onMouseEnter(e);
                }
            });
            map.on("mouseleave", layer.id, (e) => {
                map.getCanvas().style.cursor = "";
                if (onMouseLeave) {
                    onMouseLeave(e);
                }
            });
            map.on("mousemove", layer.id, (e) => {
                map.getCanvas().style.cursor = "pointer";
                if (onMouseMove) {
                    const features = map.queryRenderedFeatures(e.point);
                    onMouseMove(e, features);
                }
            });
        });
        return () => {
            layers.forEach((layer) => {
                map.removeLayer(layer.id);
            });
            map.removeSource(id);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (map.getSource(id)) {
        map.getSource(id).setData(data);
    }
    else {
        map.addSource(id, {
            type: "geojson",
            data,
        });
    }
    layers.forEach((layer) => {
        if (map.getLayer(layer.id)) {
            map.removeLayer(layer.id);
        }
        map.addLayer(layer);
    });
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.GeoJSON = (0, context_1.withMap)(GeoJSONComponent);
//# sourceMappingURL=geojson.js.map